export enum MaskType {
    Email = '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]',
    PhoneNumber = '[+99] 999-999-999',
    Pesel = '99999999999',
    PostalCode = '99-999',
    NIP = '9999999999',
    KRS = '9999999999',
    BankAccountNumber = '[AA]99 9999 9999 9999 9999 9999 9999',
    Website = '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]*{1,20}[.*{2,6}][.*{1,2}]',
    Time = '99:99',
    DateFull = 'dd-mm-yyyy',
    DateMonth = 'mm-yyyy',
    DateTime = 'dd-mm-yyyy HH:MM',
    DateFullRegex = '^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$',
    DateMonthRegex = '^([0-9]{4})-(0[1-9]|1[0-2])$',
    DateTimeRegex = '^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]) ([2][0-3]|[01][0-9]):[0-5][0-9]$',
}
